import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/legal/affiliate")({
  head: () => ({ meta: [{ title: "Affiliate disclosure — NexKey.gg" }] }),
  component: () => (
    <article>
      <h1 className="font-display text-3xl font-bold">Affiliate disclosure</h1>
      <p className="mt-4 text-sm text-muted-foreground">
        Some links on NexKey.gg may be affiliate links. We may earn a commission when users purchase
        through these links. This does not influence our price comparison — prices and offers are
        shown the same way regardless of commission.
      </p>
    </article>
  ),
});
